<template>
  <nav class="bg-white dark:bg-gray-100">
    <div
      class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl p-4"
    >
      <RouterLink :to="{ name: 'home' }">
        <PhotoDiagramLogo />
      </RouterLink>
      <div class="flex flex-wrap items-center space-x-6 rtl:space-x-reverse">
        <RouterLink
          :to="{ name: 'customer-panel' }"
          class="bg-transparent my-1 mr-2 hover:bg-black text-black font-semibold hover:text-white py-1 px-4 text-sm border border-black hover:border-transparent rounded"
          >Customer panel</RouterLink
        >
        <button
          style="margin-left: 0"
          class="bg-transparent hover:bg-black text-black font-semibold hover:text-white py-1 px-4 text-sm border border-black hover:border-transparent rounded"
          @click="logout"
        >
          Logout
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { signOut } from "firebase/auth";
import { auth } from "@/firebase";
import { useMainStore } from "@/store";

import PhotoDiagramLogo from "@/components/PhotoDiagramLogo.vue";

export default {
  name: "NavBar",
  components: {
    PhotoDiagramLogo,
  },
  setup() {
    const store = useMainStore();
    return { store };
  },
  methods: {
    async logout() {
      try {
        await signOut(auth);
        this.store.clearUser();
        this.$router.push({ name: "sign-in" });
      } catch (error) {
        alert(error.message);
      }
    },
  }
};
</script>
